<template>
    <div class="create-schedule">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <span class="card-title">
                            Edit {{ handymanName }} Schedule
                            <a href="/admin/handymans/create-schedule" class="btn btn-sm btn-theme float-end"><i class="bi bi-plus-circle pe-1"></i> Create Schedule</a>
                        </span>
                    </div>
                    <div class="card-body">
                        <form class="row g-3">
                            <div class="col-md-12">
                                <table class="table table-bordered align-middle">
                                    <tbody>
                                    <tr
                                        v-for="(day, index) in scheduleData.monthDays"
                                        :key="index"
                                    >
                                        <td class="text-center" width="10%">
                                            <div>{{ day.name.toUpperCase() }}</div>
                                            <div>{{ day.displayDate }}</div>
                                        </td>
                                        <td width="80%">
                                            <template v-if="Object.keys(day.times).length > 0">
                                                <div
                                                    v-for="(time, timeIndex) in day.times"
                                                    class="d-flex gap-3 align-items-center"
                                                    :class="{'pb-2': Object.keys(day.times).length > 1 && timeIndex < Object.keys(day.times).length - 1}"
                                                >
                                                    <Select2
                                                        :name="'time_'+index"
                                                        v-model="time.startTime"
                                                        :options="timeOptions"
                                                        :settings="{ minimumResultsForSearch: 'Infinity', selectionCssClass: 'handyman-time-select', width: '125px !important' }"
                                                        class=""
                                                    />
                                                    <div>-</div>
                                                    <Select2
                                                        :name="'time_'+index"
                                                        v-model="time.endTime"
                                                        :options="timeOptions"
                                                        :settings="{ minimumResultsForSearch: 'Infinity', selectionCssClass: 'handyman-time-select', width: '125px !important' }"
                                                        class=""
                                                    />
                                                    <i @click="removeTimeSlot(index, timeIndex)" class="bi bi-x-circle cursor-pointer"></i>
                                                </div>
                                            </template>
                                            <template v-else>Unavailable</template>
                                        </td>
                                        <td class="text-center align-items-center" width="10%">
                                            <i class="bi bi-plus-lg cursor-pointer fw-bold fs-5 me-2" @click="addTimeSlot(index)"></i>
                                            <i class="bi bi-copy cursor-pointer" @click="displayFilterForDay ? displayFilterForDay = false : displayFilterForDay = day.date"></i>
                                            <div
                                                v-if="displayFilterForDay === day.date"
                                                class="card position-absolute copy-to-days-container"
                                            >
                                                <div class="card-body gap-3 align-items-center text-start ps-3 pe-3">
                                                    <h6>COPY TO</h6>
                                                    <div class="overflow-auto" style="max-height: 200px;">
                                                        <div
                                                            v-for="(copyToDay, copyToDayIndex) in copyToDaysForMonth"
                                                            :key="copyToDayIndex"
                                                            class="form-check"
                                                        >
                                                            <template v-if="copyToDay.date===day.date">
                                                                <input
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    checked="checked"
                                                                    disabled="disabled"
                                                                    :value="copyToDay.date"
                                                                    :id="'copyToDay_'+copyToDayIndex"
                                                                >
                                                                <label class="form-check-label" :for="'copyToDay_'+copyToDayIndex">{{ copyToDay.displayDate }}</label>
                                                            </template>
                                                            <template v-else>
                                                                <input
                                                                    class="form-check-input"
                                                                    type="checkbox"
                                                                    v-model="copyToDay.checked"
                                                                    checked
                                                                    :value="copyToDay.date"
                                                                    :id="'copyToDay_'+copyToDayIndex"
                                                                >
                                                                <label class="form-check-label cursor-pointer" :for="'copyToDay_'+copyToDayIndex">{{ copyToDay.displayDate }}</label>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <button @click="copyToSelectedDaysForMonth(day.date)" type="button"class="btn btn-sm btn-theme w-100 mt-3">Apply</button>
                                                </div>
                                            </div>
                                            <!--<i class="bi bi-x-circle cursor-pointer ms-2" @click="removeDateSlot(index)"></i>-->
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-12">
                                <button
                                    type="button"
                                    class="btn btn-theme float-end"
                                    :disabled="Processing"
                                    :class="{'disabled': Processing}"
                                    v-text="Processing ? 'Processing...' : 'Update Schedule'"
                                    @click="createSchedule"
                                ></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Select2 from 'vue3-select2-component';
import moment from 'moment';
import axios from 'axios';


export default {
    components: {
        Select2,
    },
    props: {
        handyman: '',
    },
    emits: ['select'], // Declare custom event here
    data() {
        return {
            Processing: false,
            handymanList: [],
            handymanOptions: [],
            timeOptions: [],
            scheduleData: {
                handymanId: this.$props.handyman,
                scheduleDate: null,
                scheduleType: 'date_range', // repeats_weekly or date_range
                calendarDays: 30,
                weekDays: [
                    { dayOfWeek: 1, name: 'Mon', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 2, name: 'Tue', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 3, name: 'Wed', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 4, name: 'Thu', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 5, name: 'Fri', times:[{startTime: '09:00', endTime: '17:00', status: 'available'}] },
                    { dayOfWeek: 6, name: 'Sat', times:[] },
                    { dayOfWeek: 0, name: 'Sun', times:[] },
                ],
                monthDays: [],
                deleteScheduleIds: [],
            },
            copyToDays:[
                { dayOfWeek: 1, name: 'Monday', checked: false },
                { dayOfWeek: 2, name: 'Tuesday', checked: false },
                { dayOfWeek: 3, name: 'Wednesday', checked: false },
                { dayOfWeek: 4, name: 'Thursday', checked: false },
                { dayOfWeek: 5, name: 'Friday', checked: false },
                { dayOfWeek: 6, name: 'Saturday', checked: false },
                { dayOfWeek: 0, name: 'Sunday', checked: false },
            ],
            copyToDaysForMonth: [],
            displayFilterForDay: false,
            handymanName: '',
        }
    },
    created() {

    },
    mounted() {
        const rangeStart = moment();
        const rangeEnd = moment().add(30, 'days');
        //this.scheduleData.scheduleDate = [rangeStart, rangeEnd];

        // Get handyman list
        this.getSchedulesForEdit();

        // Populate time options
        this.populateTimeOptions();

    },
    computed: {

    },
    methods: {
        getSchedulesForEdit() {
            let self = this;
            axios.post('/admin/handymans/get-schedules-for-edit', {handyman_id: this.$props.handyman})
                .then(response => {
                    const data = response.data.schedules;
                    self.handymanName = data[0]?.full_name;
                    // Initialize the array to store schedule data
                    let schedules = [];

                    data.forEach(schedule => {
                        const scheduleDate = moment(schedule.schedule_date);
                        const startTime = moment(schedule.start_time, 'HH:mm:ss');
                        const endTime = moment(schedule.end_time, 'HH:mm:ss');

                        // Convert schedule date to a standard format for comparison
                        const formattedDate = scheduleDate.format('YYYY-MM-DD');

                        // Check if there's already an entry for this date
                        let existingSchedule = schedules.find(s => s.date === formattedDate);

                        if (existingSchedule) {
                            // Date exists, push new time data into the times array
                            existingSchedule.times.push({
                                startTime: startTime.format('HH:mm'),
                                endTime: endTime.format('HH:mm'),
                                status: schedule.status,
                                id: schedule.id
                            });
                        } else {
                            // No entry for this date, create a new schedule object
                            schedules.push({
                                dayOfWeek: scheduleDate.day(), // Moment.js: 0 (Sunday) to 6 (Saturday)
                                name: scheduleDate.format('ddd'), // Abbreviated day name (Mon, Tue, etc.)
                                date: formattedDate, // Using a consistent format for easy comparison
                                displayDate: scheduleDate.format('DD/MM'),
                                times: [{
                                    startTime: startTime.format('HH:mm'),
                                    endTime: endTime.format('HH:mm'),
                                    status: schedule.status,
                                    id: schedule.id
                                }]
                            });

                            // Prepare the filter data
                            self.copyToDaysForMonth.push({
                                dayOfWeek: scheduleDate.day(),
                                dayName: scheduleDate.format('dddd'),
                                date: scheduleDate.format('DD/MM/YYYY'),
                                displayDate: scheduleDate.format('MMMM DD, YYYY'),
                                checked: false
                            });
                        }
                    });
                    // Assign the schedules to scheduleData
                    self.scheduleData.monthDays = schedules;
                });
        },
        populateTimeOptions() {
            this.timeOptions = [];
            const startTime = moment().startOf('day'); // Start at 12:00 AM
            const endTime = moment().endOf('day'); // End at 11:59 PM

            let currentTime = startTime;

            while (currentTime <= endTime) {
                // Custom format for hours without leading zero
                let hour = currentTime.format('h');
                let minute = currentTime.format('mm');
                let ampm = currentTime.format('A');

                // Concatenating hour, minute, and AM/PM without space for the 'text'
                const text = `${hour}:${minute} ${ampm}`;

                // Keeping the ID in 24-hour format for consistency
                const id = currentTime.format('HH:mm');

                this.timeOptions.push({ id, text });

                // Increment by 5 minutes
                currentTime.add(15, 'minutes');
            }
        },

        // Remove the time from the times array
        removeTimeSlot(dayIndex, timeIndex) {
            // Check if scheduleType is repeats_weekly
            if(this.scheduleData.scheduleType == 'repeats_weekly') {
                this.scheduleData.weekDays[dayIndex].times.splice(timeIndex, 1);
            }
            else if(this.scheduleData.scheduleType == 'date_range') {
                // Before delete the time from the times array get id from the time
                const timeId = this.scheduleData.monthDays[dayIndex].times[timeIndex].id;
                // Check if not undefined or null and not empty
                if(timeId !== undefined && timeId !== null && timeId !== '') {
                    this.scheduleData.deleteScheduleIds.push(timeId);
                }
                this.scheduleData.monthDays[dayIndex].times.splice(timeIndex, 1);
            }
        },

        // Add the time to the times array
        addTimeSlot(dayIndex) {
            // Check if scheduleType is repeats_weekly
            if(this.scheduleData.scheduleType == 'repeats_weekly') {
                this.scheduleData.weekDays[dayIndex].times.push({startTime: '09:00', endTime: '17:00', status: 'available'});
            }
            else if(this.scheduleData.scheduleType == 'date_range') {
                this.scheduleData.monthDays[dayIndex].times.push({startTime: '09:00', endTime: '17:00', status: 'available'});
            }

        },

        // Remove date slot from the main schedule
        removeDateSlot(dayIndex) {
            this.scheduleData.monthDays.splice(dayIndex, 1);
        },

        copyToSelectedDays(copyDay) {
            // Find the day from the schedule weekDays array by day
            // Access the weekDays array
            const weekDays = this.scheduleData.weekDays;

            // 1. Find the data for copyDay in the scheduleData object
            const dayData = weekDays.find(day => day.dayOfWeek === copyDay);

            if(dayData) {
                // 2. Find the days that are checked: true in the copyToDays array
                const enabledDays = this.copyToDays.filter(day => day.checked === true).map(day => day.dayOfWeek);

                if(enabledDays.length > 0) {
                    // 3. Replace the times in scheduleData for each enabled day with the times from day=4
                    this.scheduleData.weekDays.forEach(weekDay => {
                        if (enabledDays.includes(weekDay.dayOfWeek)) {
                            weekDay.times = JSON.parse(JSON.stringify(dayData.times));
                        }
                    });
                }
            }

            // Hide the filter
            this.displayFilterForDay = false;

            // Mark all days as not checked
            this.copyToDays.forEach(day => {
                day.checked = false;
            })
        },

        // Copy to selected days for the month
        copyToSelectedDaysForMonth(copyDate) {
            // Access the monthDays array
            const monthDays = this.scheduleData.monthDays;

            // 1. Find the data for copyDay in the scheduleData object
            const dayData = monthDays.find(day => day.date == copyDate);

            if(dayData) {
                // 2. Find the days that are checked: true in the copyToDaysForMonth array
                const enabledDays = this.copyToDaysForMonth.filter(day => day.checked === true).map(day => day.date);

                if(enabledDays.length > 0) {
                    // 3. Replace the times in scheduleData for each enabled day with the times from day=4
                    this.scheduleData.monthDays.forEach(monthDay => {
                        if (enabledDays.includes(monthDay.date)) {
                            monthDay.times = JSON.parse(JSON.stringify(dayData.times));
                        }
                    });
                }
            }

            // Hide the filter
            this.displayFilterForDay = false;

            // Mark all days as not checked
            this.copyToDaysForMonth.forEach(day => {
                day.checked = false;
            })
        },

        createSchedule() {
            let self = this;
            this.Processing = true;
            axios.post('/admin/handymans/update-schedule', self.scheduleData)
                .then(response => {
                    if (response.data.status == 'success') {
                        self.$notification(response.data.status, response.data.message);
                        window.location.href = response.data.redirect_url;
                    }
                });
        }
    },
    watch: {

    }
}
</script>
<style>
.select2-container--open .select2-dropdown--below{
    z-index: 99999;
}
</style>
